import styles from "./sensor-event-item.module.css";

export type SensorEventItemProps = {
    eventType: string;
    sensorType: string;
    timestamp: string;
};

function SensorEventItem(props: SensorEventItemProps) {
    const render = () => {
        return (
            <div className={styles["sensor-event-item"]}>
                <div className={styles["left"]}>
                    <div className={styles["event-type"]}>
                        {props.eventType}
                    </div>
                    <div className={styles["sensor-type"]}>
                        {props.sensorType}
                    </div>
                </div>
                <div className={styles["right"]}>
                    <div className={styles["sensor-type"]}>
                        {props.timestamp}
                    </div>
                </div>
            </div>
        );
    };

    return render();
}

export default SensorEventItem;
